import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./timestampscanning.component.html",
})
export class TimeStampScanningComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		HomeroomID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		GroupID: 0,
		TimeScanTypeID: 0,
		ScanStationID: 0,
		startDate: new Date(),
		endDate: new Date(),
		ImageLogo: "",
	};

	schoolList: any = [];
	homeroomList: any = [];
	gradeList: any = [];
	academyList: any = [];
	groupList: any = [];
	timeScanTypeDescList: any = [];
	scanStationList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 259;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(259);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.HomeroomList();
		this.AcademyList();
		this.GradeList();
		this.GroupList();
		this.TimeScanTypeList();
		this.ScanStationList();
		this.loadLogolist();
	}

	private HomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.homeroomList = response;

				if (this.homeroomList.length > 1) {
					this.homeroomList.unshift({
						HomeroomID: 0,
						HomeroomDesc: "All Homerooms",
					});
				} else {
					this.report.HomeroomID = this.homeroomList[0].HomeroomID;
				}
			},
			(error) => {}
		);
	}

	private AcademyList() {
		this.report.AcademyID = 0;
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.academyList = response;

				if (this.academyList.length >= 0) {
					this.academyList.unshift({
						AcademyID: 0,
						AcademyDesc: "All Academies",
					});
				} else {
					this.report.AcademyID = this.academyList[0].AcademyID;
				}
			},
			(error) => {}
		);
	}

	private TimeScanTypeList() {
		this.report.TimeScanTypeID = 0;
		var result = this.reportService.TimeScanTypeGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.timeScanTypeDescList = response;

				if (this.timeScanTypeDescList.length > 1) {
					// this.timeScanTypeDescList.unshift({
					//     TimeScanTypeID: "All Time Scan Types",
					//     TimeScanTypeDesc: "All Time Scan Types"
					// })
					this.report.TimeScanTypeID = this.timeScanTypeDescList[0].TimeScanTypeID;
				} else {
					this.report.TimeScanTypeID = this.timeScanTypeDescList[0].TimeScanTypeID;
				}
			},
			(error) => {}
		);
	}

	private ScanStationList() {
		this.report.ScanStationID = 0;
		var result = this.reportService.ScanStationGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.scanStationList = response;

				if (this.scanStationList.length >= 0) {
					this.scanStationList.unshift({
						ScanStationID: "All Stations",
						ScanStation1: "All Stations",
					});
					this.report.ScanStationID = this.scanStationList[0].ScanStationID;
				} else if (this.scanStationList.length == 1) {
					this.report.ScanStationID = this.scanStationList[0].ScanStationID;
				}
				// else  {
				//     this.scanStationList.push({
				//         ScanStationID: 0,
				//         ScanStation1: "No Record found"
				//     })
				// }
			},
			(error) => {}
		);
	}

	private GradeList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.gradeList = response;

				if (this.gradeList.length > 1) {
					this.gradeList.unshift({
						GradeLevelID: 0,
						GradeLevelDesc: "All Grades",
					});
				} else {
					this.report.GradeLevelID = this.gradeList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private GroupList() {
		this.report.GroupID = 0;

		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.groupList = response;

				if (this.groupList.length >= 0) {
					this.groupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
					this.report.GroupID = this.groupList[0].GroupID;
				} else if (this.groupList.length == 1) {
					this.report.GroupID = this.groupList[0].GroupID;
				}
				// else  {
				//     this.groupList.push({
				//         GroupID: 0,
				//         GroupName: "No Record found"
				//     })
				// }
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.HomeroomID) {
		//     this.errorMessage = "Select the Homeroom";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 259;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam = this.report.SchoolID + "|SchoolID";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.AcademyID + "|AcademyID";
		strParam += "," + this.report.HomeroomID + "|HomeroomID";
		strParam += "," + this.report.GroupID + "|GroupID";
		strParam += "," + this.report.ScanStationID + "|Scanstation";
		strParam += "," + this.report.TimeScanTypeID + "|TimeScanTypeID";
		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";

		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
